import styled from "styled-components";

export const SupportSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin: auto;
  height: 100%;
  margin-block: 40px;
  @media only screen and (min-width: 1400px) {
    width: 62%;
  }
  @media only screen and (max-width: 1400px) {
    width: 70%;
  }
  @media only screen and (max-width: 968px) {
    width: 70%;
  }
  @media only screen and (max-width: 600px) {
    width: 100%;
  }
`;
